import React from 'react';

import { SVGComponentProps } from './svg.types';

const PhoneSVG = ({
  fill = 'currentColor',
  size = '1em',
  wrapperClass,
  ...otherProps
}: SVGComponentProps) => {
  return (
    <span className={`inline-block ${wrapperClass || ''}`}>
      <svg
        width={size}
        height={size}
        viewBox="0 0 11 11"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...otherProps}
      >
        <path
          d="M10.7005 8.07289L9.16545 6.53781C8.61721 5.98956 7.68519 6.20888 7.4659 6.92158C7.30142 7.41502 6.75318 7.68914 6.25976 7.57947C5.16327 7.30535 3.68301 5.87992 3.40889 4.7286C3.24442 4.23516 3.57336 3.68692 4.06678 3.52247C4.7795 3.30317 4.9988 2.37115 4.45055 1.82291L2.91547 0.287828C2.47688 -0.0959427 1.81898 -0.0959427 1.43521 0.287828L0.39355 1.32949C-0.648114 2.42598 0.503198 5.33167 3.07994 7.90842C5.65669 10.4852 8.56238 11.6913 9.65887 10.5948L10.7005 9.55315C11.0843 9.11455 11.0843 8.45666 10.7005 8.07289Z"
          fill="#BCBEC2"
        />
      </svg>
    </span>
  );
};

export default PhoneSVG;
